import React from "react";
import { Controller, Control } from "react-hook-form";
import { IonList, IonItem, IonCheckbox, IonLabel } from "@ionic/react";
import { choicesConfig } from "./pollConfig";
import { SurveyAnswers } from "@core/types";
import { useTranslation } from "react-i18next";

interface ChoiceListProps {
  control: Control<SurveyAnswers>;
}

const ChoiceList: React.FC<ChoiceListProps> = ({ control }) => {
  const { t } = useTranslation();
  const handleChoiceChange = (value: string[], id: string, allowSelectTheSameTime: boolean) => {
    let newValue = [...value];

    if (newValue.includes(id)) {
      newValue = newValue.filter((selectedId) => selectedId !== id);
    } else {
      if (
        allowSelectTheSameTime &&
        newValue.some((selectedId) => choicesConfig.find((config) => config.id === selectedId)?.allowSelectTheSameTime)
      ) {
        newValue.push(id);
      } else {
        newValue = [id];
      }
    }

    newValue = [...new Set(newValue)];

    return newValue;
  };

  return (
    <Controller
      name="choice"
      rules={{
        required: t("Please select one of the options"),
      }}
      control={control}
      render={({ field: { onChange, value } }) => (
        <>
          <IonLabel>
            <span className="font-bold">{t("To register, please answer a few questions")}</span>
            <span className="ml-1 text-[--ion-color-danger]">*</span>
          </IonLabel>
          <IonList className="flex flex-col gap-2">
            {choicesConfig.map(({ id, choice, allowSelectTheSameTime }, index) => (
              <IonItem
                key={index}
                onClick={() => onChange(handleChoiceChange(value || [], id, allowSelectTheSameTime))}
                lines="none"
              >
                <IonCheckbox slot="start" checked={value?.includes(id)}></IonCheckbox>
                <IonLabel className="ion-text-wrap">{choice}</IonLabel>
              </IonItem>
            ))}
          </IonList>
        </>
      )}
    />
  );
};

export default ChoiceList;
